import { alpha } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DoubleCaretLeft from "components/Icons/DoubleCaretLeft";
import useSidebar from "../../../SidebarProvider/useSidebar";
import { useTranslation } from "react-i18next";
import TooltipHelper from "components/TooltipHelper";
import { useMemo } from "react";
import useSidebarActions from "components/Sidebar/SidebarProvider/useSidebarActions";

function SidebarExpandCollapse() {
  const { t } = useTranslation();
  const { open, alwaysClosed } = useSidebar();
  const { toggleSidebar } = useSidebarActions();

  const title = useMemo(
    () => (open ? t("global.collapse_sidebar_label") : t("global.expand_sidebar_label")),
    [open, t]
  );

  return (
    <TooltipHelper placement="right" title={title}>
      <span>
        <IconButton
          aria-label={title}
          size="small"
          data-open={open}
          onClick={toggleSidebar}
          disabled={alwaysClosed}
          sx={(theme) => ({
            padding: "4px",
            "&:hover": { backgroundColor: alpha(theme.palette.grey[120], 0.5), borderColor: "grey.120" },
            "&[data-open='false']": { transform: "rotate(-180deg)" },
            "&.Mui-disabled": { ".MuiSvgIcon-root": { color: theme.palette.grey[100] } },
          })}
        >
          <DoubleCaretLeft sx={{ fontSize: 20 }} htmlColor="white" />
        </IconButton>
      </span>
    </TooltipHelper>
  );
}

export default SidebarExpandCollapse;
